import { useEffect, useState } from "react";
import api from "@/lib/api";

// Loads an auth-protected image (Bearer header) into an object URL, so
// private poster thumbnails never need a public URL.
export function useAuthedImage(path, bust = "") {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!path) return undefined;
    let url = null;
    let live = true;
    setFailed(false);
    api.get(path, { responseType: "blob" })
      .then(({ data }) => { if (!live) return; url = URL.createObjectURL(data); setSrc(url); })
      .catch(() => { if (live) setFailed(true); });
    return () => { live = false; if (url) URL.revokeObjectURL(url); };
  }, [path, bust]);
  return { src, failed };
}

export function AuthedImage({ path, bust, alt, className, testid }) {
  const { src, failed } = useAuthedImage(path, bust);
  if (failed) return <div className={`${className} bg-stone-100 flex items-center justify-center text-[10px] text-stone-400`} data-testid={testid}>No preview</div>;
  if (!src) return <div className={`${className} bg-stone-100 animate-pulse`} data-testid={testid} />;
  return <img src={src} alt={alt} className={className} data-testid={testid} />;
}

// Axios blob error bodies → readable message.
export async function blobErrorMessage(err, fallback) {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try { const j = JSON.parse(await data.text()); return j.detail || fallback; } catch { return fallback; }
  }
  return data?.detail || fallback;
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.setAttribute("data-poster-download", "1");
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function filenameFromDisposition(headers, fallback) {
  const cd = headers?.["content-disposition"] || "";
  const m = /filename="?([^";]+)"?/i.exec(cd);
  return m ? m[1] : fallback;
}

export const FIELD_META = [
  { key: "franchise", label: "Franchise heading", section: "heading", multiline: true },
  { key: "description", label: "Project description", section: "description", multiline: true },
  { key: "name", label: "Contact name", section: "contact" },
  { key: "email", label: "Email address", section: "contact" },
  { key: "phone", label: "Telephone", section: "contact" },
];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }); } catch { return "—"; }
};
